import React, { useState } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';

const { TextArea } = Input;
const { Option } = Select;

const CreateTicketModal = ({
  visible,
  onCancel,
  onCreate,
  aiCharacters = []
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      await onCreate(values);

      form.resetFields();
      setLoading(false);
      message.success('Ticket created successfully');
    } catch (error) {
      setLoading(false);
      if (error.errorFields) {
        // Validation error
        return;
      }
      console.error('Error creating ticket:', error);
      message.error('Failed to create ticket');
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Create New Ticket"
      open={visible}
      onOk={handleCreate}
      onCancel={handleCancel}
      okText="Create Ticket"
      confirmLoading={loading}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        name="create_ticket_form"
      >
        <Form.Item
          name="title"
          label="Title"
          rules={[
            {
              required: true,
              message: 'Please enter a ticket title'
            },
            {
              max: 255,
              message: 'Title cannot exceed 255 characters'
            }
          ]}
        >
          <Input placeholder="Brief description of the issue" />
        </Form.Item>

        <Form.Item
          name="description"
          label="Description"
          rules={[
            {
              required: true,
              message: 'Please enter a detailed description'
            }
          ]}
        >
          <TextArea
            rows={4}
            placeholder="Detailed description of the issue, what you've tried, etc."
          />
        </Form.Item>

        <Form.Item
          name="priority"
          label="Priority"
          rules={[
            {
              required: true,
              message: 'Please select a priority level'
            }
          ]}
          initialValue="medium"
        >
          <Select placeholder="Select priority level">
            <Option value="low">Low</Option>
            <Option value="medium">Medium</Option>
            <Option value="high">High</Option>
            <Option value="critical">Critical</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="assigned_to"
          label="Assign To (Optional)"
        >
          <Select
            placeholder="Select a character to assign this ticket to"
            allowClear
          >
            {aiCharacters.map((character) => (
              <Option key={character.id} value={character.name}>
                {character.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateTicketModal;
